export default (set, data) => set(
  () => ({
    drawer: { ...data }
  }),
  false,
  { type: 'configurator/updateDrawer', data }
);
